module.exports = __webpack_public_path__ + "img/celeste.704f3c47.jpg";